/**
 * ENR-4044: Studio Portal is often embedded in the CRM marketplace iframe.
 * When true, expired JWT recovery should re-run SSO via /exchange-user-context
 * instead of sending the user to the standalone /login screen.
 */
export function isEmbeddedInCrmIframe(
  win: Pick<Window, 'self' | 'top'> = window,
): boolean {
  try {
    return win.self !== win.top;
  } catch {
    // Cross-origin access to window.top can throw; treat as embedded.
    return true;
  }
}
